import React, { Component } from 'react'
import { Checkbox, Icon } from 'antd'

export default class extends Component {
  handleCheckbox = (id) => {
    const { updateUploadedTableById } = this.props

    if (updateUploadedTableById) {
      updateUploadedTableById(id)
    }
  }

  handleRemoveUploadedFile = (guid) => {
    const { deleteStorageResourceById, removeUploadedFile, updateUploadedTable } = this.props

    if (deleteStorageResourceById && removeUploadedFile) {
      deleteStorageResourceById(guid).then(() => {
        removeUploadedFile(guid)
        updateUploadedTable(false)
      })
    }
  }

  render () {
    const { uploadedFiles, uploadedTable } = this.props

    return (
      uploadedFiles.map((file, index) =>
        <div className='upload__item' key={index}>
          <div className='file-uploader'>
            <div className='file-uploader__inner'>
              <div className='file-uploader__part' style={{ alignItems: 'flex-start' }}>
                <div className='file-uploader__loading'>
                  <Checkbox
                    checked={uploadedTable.keys.includes(file.id)}
                    onChange={() => this.handleCheckbox(file.id)}
                  />
                </div>
                <div className={'file-uploader__name'}>
                  <div>{ file.name }.{ file.extension }</div>
                  { file.tags.length > 0 &&
                  <div className='user-cell__groups'>
                    { file.tags.map((tag, index) => <div key={index} className='user-cell__group'>{ tag.value }</div>) }
                  </div>
                  }
                </div>
              </div>
              <div className='file-uploader__part'>
                <div className='file-uploader__delete' onClick={() => this.handleRemoveUploadedFile(file.guid)}>
                  <Icon type='close' />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/StorageUploadModal/components/Table/Table.jsx